/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useState } from "react";
import clsx from 'clsx'
import DateTimePicker from 'react-datetime-picker'
import { CustomSelect } from './select-react/CustomSelect'
import { getModels as getProduct } from '../../../modules/product-management/core/_requests'
import { ModelQueryResponse as ProductQueryResponse } from '../../../modules/product-management/core/_models'
import { getModels as getProductCategory } from '../../../modules/productcategory-management/core/_requests'
import { ModelQueryResponse as ProductCategoryQueryResponse } from '../../../modules/productcategory-management/core/_models'
import { getModels as getinquirystatus } from '../../../modules/inquirystatus-management/core/_requests'
import { ModelQueryResponse as InquirystatusQueryResponse } from '../../../modules/inquirystatus-management/core/_models'
import { getModels as getinquirytype } from '../../../modules/inquirytype-management/core/_requests'
import { ModelQueryResponse as InquirytypeQueryResponse } from '../../../modules/inquirytype-management/core/_models'
import { getModels as getinquirysources } from '../../../modules/inquirysource-management/core/_requests'
import { ModelQueryResponse as InquirysourceQueryResponse } from '../../../modules/inquirysource-management/core/_models'
import { getModels as getinquirysubsources } from '../../../modules/inquirysubsource-management/core/_requests'
import { ModelQueryResponse as InquirysubsourceQueryResponse } from '../../../modules/inquirysubsource-management/core/_models'
import { getUsers, getUserById } from '../../../modules/apps/user-management/core/_requests'
import { UsersQueryResponse } from '../../../modules/apps/user-management/core/_models'
// import { DashboardQueryResponce } from "../core/_models";
// import { getdashborddata } from "../core/_requests";
import { SelectedDataContext } from './SelectedDataContext'
// import { isEmptyArray } from "formik";
// import { isEmpty } from "lodash";

type Props = {
  className?: string
  onFilterSubmit: (filters: any) => void;
  // model?: DashboardCountModel
}
const FilterForm = ({ className, onFilterSubmit }: Props) => {
  const { selectedData, setSelectedData } = useContext(SelectedDataContext) as any;

  // console.log('get_selectedvalue_filter',selectedData?.listName)
  const [selectedProducts, setSelectedProducts] = useState<unknown[]>([]);
  const [selectedCategoryProducts, setSelectedCategoryProducts] = useState<unknown[]>([]);
  const [selectedInqStatus, setSelectedInqStatus] = useState<unknown[]>([]);
  const [selectedInqType, setSelectedInqType] = useState<unknown[]>([]);
  const [selectedInqSource, setSelectedInqSource] = useState<unknown[]>([]);
  const [selectedInqSubsource, setSelectedInqSubsource] = useState<unknown[]>([]);
  const [selectedInqExe, setSelectedInqExe] = useState<unknown[]>([]);
  const [selectedFollowup, setSelectedFollowup] = useState<unknown[]>([]);
  const [selectedSubSourseType, setSelectedSubSourseType] = useState<unknown[]>([]);

  const [selectedStartDate, setSelectedStartDate] = useState<Date | undefined>();
  const [selectedEndDate, setSelectedEndDate] = useState<Date | undefined>();
  const [selectedOrderStartDate, setSelectedOrderStartDate] = useState<Date | undefined>();
  const [selectedOrderEndDate, setSelectedOrderEndDate] = useState<Date | undefined>();
  const [selectedMou, setSelectedMou] = useState<unknown[]>([]);
  const [selectedMouProducts, setSelectedMouProducts] = useState<unknown[]>([]);


  const [product, setProduct] = useState<ProductQueryResponse>();
  const [productLoading, setProductLoading] = useState(true);
  const [formSubmitted, setFormSubmitted] = useState(false);

  const searchParams = new URLSearchParams(window.location.search);
  const FilterValue = searchParams.toString();
  const keyValuePairs = FilterValue.split("&");
  const params = {} as any;
  keyValuePairs.forEach((pair) => {
    const [key, value] = pair.split("=");
    if (key === 'followup_option') {
      params[key] = value;
    } else {
      params[key] = parseInt(value);
    }

  });


  // useEffect(() => {
  //   if (FilterKey === 'product_Id' && selectedProducts.length === 0) {
  //     setSelectedProducts([parseInt(FilterId)]);
  //     handleFormSubmit();
  //   }
  //   // console.log('selectedProductsIN', selectedProducts)

  // }, [product]);

  useEffect(() => {
    getProduct('').then((result) => {
      setProduct(result);
      setProductLoading(false);
    });
  }, []);

  const [productMou, setMouProduct] = useState<ProductQueryResponse>();
  const [productMouLoading, setMouProductLoading] = useState(true);

  useEffect(() => {
    getProduct('has_mou=yes').then((result) => {
      setMouProduct(result);
      setMouProductLoading(false);

      const productIds = result?.data?.map((product) => product.id);
      setSelectedMouProducts(productIds || []);

    });
  }, [selectedMou]);


  const [productcategory, setProductcategory] = useState<ProductCategoryQueryResponse>();
  const [productcategoryLoading, setProductcategoryLoading] = useState(true);
  useEffect(() => {
    if (params.hasOwnProperty('product_cate_Id')) {
      getProductCategory('NameFilterProductCateId').then((result) => {
        setProductcategory(result);
        setProductcategoryLoading(false);
      });
    } else {
      if (selectedProducts.length > 0) {
        getProductCategory('product_id_In=' + selectedProducts).then((result) => {
          setProductcategory(result);
          setProductcategoryLoading(false);
        });
      } else {
        setSelectedCategoryProducts([]);
        setProductcategory(undefined);
        setProductcategoryLoading(false);
      }
    }
  }, [selectedProducts]);
  // console.log("selectedCategoryProducts",selectedProducts)

  // useEffect(() => {
  //   if (FilterKey === 'product_cate_Id' && selectedCategoryProducts.length === 0) {
  //     setSelectedCategoryProducts([parseInt(FilterId)]);
  //     handleFormSubmit();

  //   }
  //   console.log('selectedCategoryProductsIN ', selectedCategoryProducts)

  // }, [productcategory]);

  // console.log('product',selectedProducts);
  const [inquirystatuses, setInquirystatuses] = useState<InquirystatusQueryResponse>();
  const [inquirystatusLoading, setInquirystatusLoading] = useState(true);
  useEffect(() => {
    getinquirystatus('').then((result) => {
      setInquirystatuses(result);
      setInquirystatusLoading(false);
    });
  }, []);

  // useEffect(() => {
  //   if (FilterKey === 'inq_status_Id' && selectedInqStatus.length === 0) {
  //     setSelectedInqStatus([parseInt(FilterId)]);
  //     handleFormSubmit();

  //   }
  //   console.log('selectedInqStatusIN ', selectedInqStatus)

  // }, [inquirystatuses]);

  const [inquirytypes, setInquiryTypes] = useState<InquirytypeQueryResponse>();
  const [inquirytypesLoading, setInquiryTypesLoading] = useState(true);
  useEffect(() => {
    getinquirytype('').then((result) => {
      setInquiryTypes(result);
      setInquiryTypesLoading(false);
    });
  }, []);

  const [inquirysources, setInquirySources] = useState<InquirysourceQueryResponse>();
  const [inquirysourceLoading, setInquirysourceLoading] = useState(true);
  useEffect(() => {
    getinquirysources('').then((result) => {
      setInquirySources(result);
      setInquirysourceLoading(false);
    });
  }, []);

  const [inquirysubsources, setInquirysubSources] = useState<InquirysubsourceQueryResponse>();
  const [inquirysubsourceLoading, setInquirysubsourceLoading] = useState(true);

  useEffect(() => {
    if (params.hasOwnProperty('inq_subsource_Id')) {
      getinquirysubsources('').then((result) => {
        setInquirysubSources(result);
        setInquirysubsourceLoading(false);
      });
    } else {
      if (selectedInqSource.length > 0) {
        getinquirysubsources('inquiry_source_id_In=' + selectedInqSource).then((result: any) => {
          setInquirysubSources(result);
          setInquirysubsourceLoading(false);
        });
      }
      else {
        setSelectedInqSubsource([]);
        setInquirysubSources(undefined);
        setInquirysubsourceLoading(false);
      }
    }
  }, [selectedInqSource]);
  const [users, setUsers] = useState<UsersQueryResponse>();
  const [usersLoading, setUsersLoading] = useState(true);

  useEffect(() => {
    getUsers('role_name=sales team').then((result) => {
      setUsers(result);
      setUsersLoading(false);
    });
  }, []);

  useEffect(() => {
    if (params.hasOwnProperty('product_Id') && selectedProducts.length === 0) {
      setSelectedProducts([params['product_Id']]);
    }
    if (params.hasOwnProperty('product_cate_Id') && selectedCategoryProducts.length === 0) {
      setSelectedCategoryProducts([params['product_cate_Id']]);
    }
    if (params.hasOwnProperty('inq_status_Id') && selectedInqStatus.length === 0) {
      setSelectedInqStatus([params['inq_status_Id']]);
    }
    if (params.hasOwnProperty('inq_type_Id') && selectedInqType.length === 0) {
      setSelectedInqType([params['inq_type_Id']]);

    }
    if (params.hasOwnProperty('inq_source_Id') && selectedInqSource.length === 0) {
      setSelectedInqSource([params['inq_source_Id']]);

    }
    if (params.hasOwnProperty('inq_subsource_Id') && selectedInqSubsource.length === 0) {
      setSelectedInqSubsource([params['inq_subsource_Id']]);

    }
    if (params.hasOwnProperty('inq_Exe_Id') && selectedInqExe.length === 0) {
      setSelectedInqExe([params['inq_Exe_Id']]);
    }
    if (params.hasOwnProperty('followup_option') && selectedFollowup.length === 0) {
      setSelectedFollowup(params['followup_option']);
    }
    // if (params.hasOwnProperty('followup_option') && selectedSubSourseType.length === 0) {
    //   setSelectedSubSourseType(params['followup_option']);
    // }

    if (selectedProducts.length > 0 || selectedCategoryProducts.length > 0 || selectedInqStatus.length > 0 || selectedInqType.length > 0 || selectedInqSource.length > 0 || selectedInqSubsource.length > 0 || selectedInqExe.length > 0 || selectedFollowup.length > 0) {
      handleFormSubmit();
    }
  }, [users]);

  const resetForm = () => {
    setSelectedProducts([]);
    setSelectedCategoryProducts([]);
    setSelectedInqStatus([]);
    setSelectedInqType([]);
    setSelectedInqSource([]);
    setSelectedInqSubsource([]);
    setSelectedInqExe([]);
    setSelectedFollowup([]);
    setSelectedSubSourseType([]);
    setSelectedMou([]);
    setSelectedMouProducts([]);
    setSelectedStartDate(undefined);
    setSelectedEndDate(undefined);
    setSelectedOrderStartDate(undefined);
    setSelectedOrderEndDate(undefined);
  };
  const handleFormReset = () => {
    resetForm();
    const Reset = {
      product_Id: '',
      product_cate_Id: '',
      inq_status_Id: '',
      inq_type_Id: '',
      inq_source_Id: '',
      inq_subsource_Id: '',
      inq_Exe_Id: '',
      start_date: '',
      end_date: '',
      order_start_date: '',
      order_end_date: '',
      followup_option: '',
      selected_mou: '',
      selected_MouProducts: '',
      selected_subsourse_type: ''
    };
    onFilterSubmit(Reset);
    // setSelectedData(null);
  };
  const handleFormSubmit = () => {
    if (selectedEndDate || selectedStartDate || selectedOrderStartDate || selectedOrderEndDate || selectedProducts.length > 0 || selectedCategoryProducts.length > 0 || selectedInqStatus.length > 0 || selectedInqType.length > 0 || selectedInqSource.length > 0 || selectedInqSubsource.length > 0 || selectedInqExe.length > 0 || selectedFollowup.length > 0 || selectedMou.length > 0 || selectedMouProducts.length > 0 || selectedSubSourseType.length > 0) {
      const filters = {
        product_Id: selectedProducts ? selectedProducts : [],
        product_cate_Id: selectedCategoryProducts ? selectedCategoryProducts : '',
        inq_status_Id: selectedInqStatus ? selectedInqStatus : '',
        inq_type_Id: selectedInqType ? selectedInqType : '',
        inq_source_Id: selectedInqSource ? selectedInqSource : '',
        inq_subsource_Id: selectedInqSubsource ? selectedInqSubsource : '',
        inq_Exe_Id: selectedInqExe ? selectedInqExe : '',
        start_date: selectedStartDate ? selectedStartDate : '',
        end_date: selectedEndDate ? selectedEndDate : '',
        order_start_date: selectedOrderStartDate ? selectedOrderStartDate : '',
        order_end_date: selectedOrderEndDate ? selectedOrderEndDate : '',
        followup_option: selectedFollowup ? selectedFollowup : '',
        selected_mou: selectedMou ? selectedMou : '',
        selected_MouProducts: selectedMouProducts ? selectedMouProducts : '',
        selected_subsourse_type: selectedSubSourseType ? selectedSubSourseType : '',

        // selectedSubSourseType

      };
      onFilterSubmit(filters);
    }
    else {
      const filters = {
        // ... add other selected filter values here
      };
      onFilterSubmit(filters);
    }

  };

  const followupOption = [
    { label: 'YES', value: 'yes' },
    { label: 'NO', value: 'no' },
    { label: 'ACTIVE', value: 'active' },
    { label: 'DEACTIVE', value: 'deactive' },
    { label: `PAST-ACTIVE FOLLOWUP`, value: 'past_active' },
    // { label: `TODAY'S FOLLOWUP`, value: 't_followup' },
    // { label: `TODAY'S TASK`, value: 't_task' },
  ];

  const SubSourseOption = [
    { label: 'B2B', value: 'b2b' },
    { label: 'B2C', value: 'b2c' },
  ];

  const MouOption = [
    { label: 'YES', value: 'yes' },
    { label: 'NO', value: 'no' },
  ];

  return (
    <div className={clsx('card', className)}>
      <div className='card-body d-flex align-items-center justify-content-between flex-wrap'>
        {/* <div className='separator border-gray-200'></div> */}
        <div className='row row-cols-4'>
          <div className='col'>
            <div className='mb-3'>
              {/* <label className='form-label fs-7 fw-semibold'>Is Active:</label> */}
              <DateTimePicker
                className={clsx(
                  'form-control form-control-solid mb-3 mb-lg-0',
                )}
                format={'dd/MM/yyyy'}
                onChange={(e) => setSelectedStartDate(e)}
                value={selectedStartDate}
                dayPlaceholder={'Start '}
                monthPlaceholder=" Date"
              />
            </div>
          </div>

          <div className='col'>
            <div className='mb-3'>
              {/* <label className='form-label fs-7 fw-semibold'>Is Active:</label> */}
              <DateTimePicker
                className={clsx(
                  'form-control form-control-solid mb-3 mb-lg-0',
                )}
                format={'dd/MM/yyyy'}
                onChange={(e) => setSelectedEndDate(e)}
                value={selectedEndDate}
                dayPlaceholder={'End '}
                monthPlaceholder="Date"
              />
            </div>
          </div>

          <div className='col'>
            <div className='mb-3'>
              {/* <label className='form-label fs-7 fw-semibold'>Is Active:</label> */}
              <DateTimePicker
                className={clsx(
                  'form-control form-control-solid mb-3 mb-lg-0',
                )}
                format={'dd/MM/yyyy'}
                onChange={(e) => setSelectedOrderStartDate(e)}
                value={selectedOrderStartDate}
                dayPlaceholder={'Order'}
                monthPlaceholder=" Start"
                yearPlaceholder=" Date"
              />
            </div>
          </div>

          <div className='col'>
            <div className='mb-3'>
              {/* <label className='form-label fs-7 fw-semibold'>Is Active:</label> */}
              <DateTimePicker
                className={clsx(
                  'form-control form-control-solid mb-3 mb-lg-0',
                )}
                format={'dd/MM/yyyy'}
                onChange={(e) => setSelectedOrderEndDate(e)}
                value={selectedOrderEndDate}
                dayPlaceholder={'Order'}
                monthPlaceholder=" End"
                yearPlaceholder=" Date"
              />
            </div>
          </div>

          <div className='col'>
            <div className='mb-3'>
              <CustomSelect
                className={'form-select-solid fw-bold'}
                options={
                  selectedMou.length > 0 ? (
                    productMou?.data?.map((object: any, index: any) => {
                      return {
                        'label': object.product_name, 'value': object.id
                      }
                    })
                  ) : (
                    product?.data?.map((object: any, index: any) => {
                      return {
                        'label': object.product_name, 'value': object.id
                      }
                    })
                  )
                }
                value={selectedProducts}
                onChange={(value: any) => {
                  if (value) {
                    setSelectedProducts(Array.prototype.map.call(value, function (v) { return v.value; }));
                    // setProductcategoryLoading(true)
                  }

                }}
                isMulti={product?.data?.map((object: any, index: any) => {
                  return {
                    'label': object.product_name, 'value': object.id
                  }
                })}
                isLoading={selectedMou.length > 0 ? productMouLoading : productLoading}
                placeholder={"Select Inquiry Products"}
              />
            </div>
          </div>

          <div className='col'>
            <div className='mb-3'>
              <CustomSelect
                className={'form-select-solid fw-bold'}
                options={productcategory?.data?.map((object: any, index: any) => {
                  return {
                    'label': object.product_category_name, 'value': object.id
                  }
                })}
                value={selectedCategoryProducts}
                onChange={(value: any) => {
                  if (value) {
                    setSelectedCategoryProducts(Array.prototype.map.call(value, function (v) { return v.value; }));
                  }

                }}
                isMulti={productcategory?.data?.map((object: any, index: any) => {
                  return {
                    'label': object.product_category_name, 'value': object.id
                  }
                })}
                isLoading={productcategoryLoading}
                placeholder={"Select Product Category"}
              />
            </div>
          </div>


          <div className='col'>
            <div className='mb-3'>
              <CustomSelect
                className={'form-select-solid fw-bold'}
                options={
                  selectedMou.length > 0 ? (inquirystatuses?.data?.map((object: any, index: any) => {
                    return {
                      'label': object.inquiry_status_name, 'value': object.id
                    }
                  })) : (
                    inquirystatuses?.data?.map((object: any, index: any) => {
                      return {
                        'label': object.inquiry_status_name, 'value': object.id
                      }
                    })
                  )
                }
                // options={
                //   selectedMou.length > 0 ? (
                //     productMou?.data?.map((object: any, index: any) => {
                //       return {
                //         'label': object.product_name, 'value': object.id
                //       }
                //     })
                //   ) : (
                //     product?.data?.map((object: any, index: any) => {
                //       return {
                //         'label': object.product_name, 'value': object.id
                //       }
                //     })  
                //   )
                // }
                value={selectedInqStatus}
                onChange={(value: any) => {
                  if (value) {
                    setSelectedInqStatus(Array.prototype.map.call(value, function (v) { return v.value; }));
                  }

                }}
                isMulti={inquirystatuses?.data?.map((object: any, index: any) => {
                  return {
                    'label': object.inquiry_status_name, 'value': object.id
                  }
                })}
                isLoading={inquirystatusLoading}
                placeholder={"Select Inq. Status"}
              />
            </div>
          </div>

          <div className='col'>
            <div className='mb-3'>
              <CustomSelect
                className={'form-select-solid fw-bold'}
                options={inquirytypes?.data?.map((object: any, index: any) => {
                  return {
                    'label': object.inquiry_type_name, 'value': object.id
                  }
                })}
                value={selectedInqType}
                onChange={(value: any) => {
                  if (value) {
                    setSelectedInqType(Array.prototype.map.call(value, function (v) { return v.value; }));
                  }

                }}
                isMulti={inquirytypes?.data?.map((object: any, index: any) => {
                  return {
                    'label': object.inquiry_type_name, 'value': object.id
                  }
                })}
                isLoading={inquirytypesLoading}
                placeholder={"Select Inq. Type"}
              />
            </div>
          </div>

          <div className='col'>
            <div className='mb-3'>
              <CustomSelect
                className={'form-select-solid fw-bold'}
                options={inquirysources?.data?.map((object: any, index: any) => {
                  return {
                    'label': object.source_name, 'value': object.id
                  }
                })}
                value={selectedInqSource}
                onChange={(value: any) => {
                  if (value) {
                    setSelectedInqSource(Array.prototype.map.call(value, function (v) { return v.value; }));
                  }

                }}
                isMulti={inquirysources?.data?.map((object: any, index: any) => {
                  return {
                    'label': object.source_name, 'value': object.id
                  }
                })}
                isLoading={inquirysourceLoading}
                placeholder={"Select Source"}
              />
            </div>
          </div>

          <div className='col'>
            <div className='mb-3'>
              <CustomSelect
                className={'form-select-solid fw-bold'}
                options={inquirysubsources?.data?.map((object: any, index: any) => {
                  return {
                    'label': object.subsource_name, 'value': object.id
                  }
                })}
                value={selectedInqSubsource}
                onChange={(value: any) => {
                  if (value) {
                    setSelectedInqSubsource(Array.prototype.map.call(value, function (v) { return v.value; }));
                  }

                }}
                isMulti={inquirysubsources?.data?.map((object: any, index: any) => {
                  return {
                    'label': object.subsource_name, 'value': object.id
                  }
                })}
                isLoading={inquirysubsourceLoading}
                placeholder={"Select Sub Source"}
              />
            </div>
          </div>

          <div className='col'>
            <div className='mb-3'>
              <CustomSelect
                className={'form-select-solid fw-bold'}
                options={users?.data?.map((object: any, index: any) => {
                  return {
                    'label': object.name, 'value': object.id
                  }
                })}
                value={selectedInqExe}
                onChange={(value: any) => {
                  if (value) {
                    setSelectedInqExe(Array.prototype.map.call(value, function (v) { return v.value; }));
                  }

                }}
                isMulti={users?.data?.map((object: any, index: any) => {
                  return {
                    'label': object.name, 'value': object.id
                  }
                })}
                isLoading={usersLoading}
                placeholder={"Select Executive"}
              />
            </div>
          </div>

          <div className='col'>
            <div className='mb-3'>
              <CustomSelect
                className={'form-select-solid fw-bold'}
                options={followupOption}
                value={selectedFollowup}
                onChange={(value: any) => {
                  if (value) {
                    setSelectedFollowup(value.value);
                  } else {
                    setSelectedFollowup([]);
                  }
                }}
                isclearable={true}
                // isMulti={followupOption}
                // isMulti={false}
                // isLoading={usersLoading}

                placeholder={"Select Followup"}
              />

            </div>
          </div>


          {/* <div className='col'>
            <div className='mb-3'>
              <Select
                className=' form-select-solid fw-bold'
                options={
                  dashboardinquiry?.data?.inquiryproducts.map((object: any, index: any) => (
                    {
                      value: object.id,
                      label: `${object.name}`
                    }
                  ))
                }
                isClearable
                styles={{
                  control: (base) => ({
                    ...base,
                    background: '#f5f8fa',
                    border: 'none',
                    borderRadius: '7px'
                  }),
                }}

                placeholder="Select Direct / Indirect"
              />
            </div>
          </div> */}

          <div className='col'>
            <div className='mb-3'>
              <CustomSelect
                className={'form-select-solid fw-bold'}
                options={MouOption}
                value={selectedMou}
                onChange={(value: any) => {
                  if (value) {
                    setSelectedMou(value.value);
                    setSelectedProducts([]);
                  } else {
                    setSelectedMou([]);
                    setSelectedProducts([]);
                    setSelectedMouProducts([]);
                  }
                }}
                isclearable={true}
                placeholder={"Select MOU"}
              />

            </div>
          </div>

          <div className='col'>
            <div className='mb-3'>
              <CustomSelect
                className={'form-select-solid fw-bold'}
                options={SubSourseOption}
                value={selectedSubSourseType}
                onChange={(value: any) => {
                  if (value) {
                    setSelectedSubSourseType(value.value);
                  } else {
                    setSelectedSubSourseType([]);
                  }
                }}
                isclearable={true}
                // isMulti={followupOption}
                // isMulti={false}
                // isLoading={usersLoading}

                placeholder={"Select B2B / B2C"}
              />
            </div>
          </div>

          <div className='col '>
            <button
              type='submit'
              className='btn btn-primary fw-semibold px-6 me-2'
              data-kt-menu-dismiss='true'
              data-kt-table-filter='filter'
              onClick={handleFormSubmit}
            >
              SUBMIT
            </button>
            <button
              type='reset'
              className='btn btn-warning text-gray-800 fw-semibold px-6'
              data-kt-menu-dismiss='false'
              data-kt-table-filter='filter'
              onClick={handleFormReset}
            >
              Reset
            </button>
          </div>

        </div>


        {/* <button
              type='button'
              className='btn btn-light btn-active-light-primary fw-semibold me-2 px-6'
              data-kt-menu-dismiss='true'
              data-kt-table-filter='reset'
            >
              Reset
            </button> */}



        {/* <a
          href='#'
          className='btn btn-primary fw-semibold'
          data-bs-toggle='modal'
          data-bs-target='#kt_modal_create_campaign'
        >
          Start Now
        </a> */}
      </div>
    </div>
  )
}

export { FilterForm }
